export class Controller {

    /** @ngInject */
    constructor(
        ApprovalPoliciesService,
        Alert,
        $state
        ) {
        this.Alert= Alert;
        this.$state= $state;
        this.ApprovalPoliciesService = ApprovalPoliciesService;
    }

    $onInit() {
        if (this.application.approvalPolicyId) {
            this.selectedPolicyId = this.application.approvalPolicyId;
        } else {
            this.selectedPolicyId = '-1';
        }
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    saveDisabled() {
        return this.isSaving || this.notModified();
    }

    notModified() {
        return this.application.approvalPolicyId === this.selectedPolicyId || (this.application.approvalPolicyId == null && this.selectedPolicyId == -1);
    }

    savePolicy(){
        this.isSaving = true;
        this.ApprovalPoliciesService.applyPolicy(this.application.id, this.selectedPolicyId, this.companyId)
            .then(()=>{
                this.Alert(
                    'success',
                    'global.messages.operation-successful'
                )
            })
            .then(() => this.$state.reload('company.manage-application'))
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/authentication-policies/approval-policy/approval-policy.controller.js